var React = require('react');

function Scroll (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"Down Arrow"),React.createElement("polygon",{"fill":"#ffffff","points":"13.5 70.09 -0.26 54.22 1.26 52.91 13.5 67.04 25.74 52.91 27.26 54.22 13.5 70.09","key":2}),React.createElement("rect",{"fill":"#ffffff","x":"12.5","y":"0.37","width":"2","height":"60","key":3})]);
}

Scroll.displayName = "Scroll";

Scroll.defaultProps = {"viewBox":"0 0 27 70"};

module.exports = Scroll;

Scroll.default = Scroll;
